/* eslint-disable warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class IndexController extends Controller {
  // Services
  @service
  paperToaster;

  @service
  router;

  @service
  store;

  /**
   * toastMessage pops a notification of success or failure.
   *
   * @param {boolean} success - Whether a success was had or not.
   * @param {string} message - The message to display
   */
  toastMessage(success, message) {
    let toastClass = 'success';
    if (!success) {
      toastClass = 'warning';
    }

    this.paperToaster.show(message, {
      duration: 6000,
      position: 'top right',
      toastClass: toastClass,
    });
  }

  /**
   * toggleEnabled flips the enabled state and instantly saves the task.
   *
   * @param {Object} task - task record.
   */
  @action
  toggleEnabled(task) {
    // store the toggled state.
    let toggledEnabledState = !task.enabled;

    // build a state string to return the action performed on save.
    let state = 'disabl';
    if (toggledEnabledState) {
      state = 'enabl';
    }

    // Update state and notify of outcome.
    task.set('enabled', toggledEnabledState);
    task
      .save()
      .then(() => {
        this.toastMessage(
          true,
          `${state}ed ${task.serviceName}'s ${task.serviceTask}`,
        );
      })
      .catch((err) => {
        this.toastMessage(
          false,
          `Error ${state}ing ${task.serviceName} ${task.serviceTask}. Error: ${err}`,
        );
      });
  }

  /**
   * viewTask transitions to the individual task to display the task logs and
   * perform specific actions on the task itself.
   *
   * @param {Object} task - task record.
   */
  @action
  viewTask(task) {
    this.router.transitionTo('cron.task', task.id);
  }
}
